<template>
  <SystemLogTable :create-user="createUser" :date="date" />
</template>
<script>
import SystemLogTable from '@/components/resources/log/SystemLogTable.vue'

export default {
  components: {
    SystemLogTable
  },
  data() {
    return {
      createUser: this.$route.query.create_user_id,
      date: this.$route.query.date,
      departments: [],
      actions: []
    }
  },
  async mounted() {
    // const create_user = this.$route.query.create_user_id
    // const date = this.$route.query.date
    // console.log(create_user, 'check user', date)
  },
  methods: {}
}
</script>
